import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { X } from '@phosphor-icons/react';
import successImage from '../../assets/images/success.svg';
import failedImage from '../../assets/images/failed.svg';
import {
  NotificationWrapper,
  NotificationHeader,
  NotificationContent,
  StatusText,
  ProgressBar,
  ProgressFill,
  ActionLink,
  CloseButton,
} from './MergeProgressNotificationStyled';

const MergeProgressNotification = ({
  progress,
  isComplete,
  mergedFileUrl,
  error,
  onClose,
  onOpenFile,
  // Optional copy overrides so other assembly-backed flows (Export as PDF,
  // the page builder) can reuse this notification without saying "Merging".
  inProgressLabel = 'Merging Files.',
  successLabel = 'Merged Successfully',
}) => {
  const hasError = !!error;

  // Auto-close merge failed toast after 5 seconds
  useEffect(() => {
    if (hasError) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // 5 seconds

      return () => {
        clearTimeout(timer);
      };
    }
  }, [hasError, onClose]);
let statusIcon;
if (hasError) {
  statusIcon = <img src={failedImage} alt="Success" style={{ width: 24, height: 24 }} />
} else if (isComplete) {
  statusIcon = <img src={successImage} alt="Success" style={{ width: 24, height: 24 }} />;
} else {
  statusIcon = <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: '#0C53BB' }} spin />} />;
}

let statusMessage;
if (hasError) {
  statusMessage = error ||'Merge Failed';
} else if (isComplete) {
  statusMessage = successLabel;
} else {
  statusMessage = (
    <>
      {inProgressLabel}{' '}
      <span style={{ color: '#16B361', marginLeft: '4px' }}>
        {progress}% Complete
      </span>
    </>
  );
}

  return (
    <NotificationWrapper>
      <NotificationHeader>
        {statusIcon}
        <NotificationContent>
          <StatusText success={isComplete} error={hasError}>
            {statusMessage}
             {isComplete && mergedFileUrl && !hasError && (
            <ActionLink onClick={onOpenFile} data-testid="open-file-link">
              Open File
            </ActionLink>
          )}
          </StatusText>

          {!isComplete && !hasError && (
            <ProgressBar>
              <ProgressFill progress={progress} />
            </ProgressBar>
          )}

         
        </NotificationContent>
      </NotificationHeader>
      <CloseButton onClick={onClose} data-testid="merge-notification-close">
        <X size={20} />
      </CloseButton>
    </NotificationWrapper>
  );
};

MergeProgressNotification.propTypes = {
  progress: PropTypes.number.isRequired,
  isComplete: PropTypes.bool.isRequired,
  mergedFileUrl: PropTypes.string,
  error: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onOpenFile: PropTypes.func,
  inProgressLabel: PropTypes.string,
  successLabel: PropTypes.string,
};

export default MergeProgressNotification;

